var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramUnlock64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "57px",
    viewBox: "0 0 46 57",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pictorgram",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-114.000000, -110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(106.500000, 106.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0.102630615,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogram",
    transform: "translate(12.000000, 26.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 40,
    height: 33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 27,
    x2: 38,
    y2: 27,
    id: "Base-plate",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Key-hole",
    transform: "translate(15.000000, 6.990891)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Focus",
    fill: "#FFCC00",
    cx: 5,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 11,
    x2: 5,
    y2: 15.0091091,
    id: "slot",
    strokeLinecap: "square"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M43,25 L43,16 C43,9.92486775 38.0751322,5 32,5 C25.9248678,5 21,9.92486775 21,16 L21,19",
    id: "Lock",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.215860, 12.143295)",
    fill: "#FFFFFF",
    id: "Line-2",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 7.92546795,
    x2: 5.28610436,
    y2: 7.92881177
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.04349348,
    y1: -1.42108547e-14,
    x2: 6.97569719,
    y2: 4.39830557
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramUnlock64);
export default __webpack_public_path__ + "static/media/pictogramUnlock64.961197332d9977c8c8133312f89c85c2.svg";
export { ForwardRef as ReactComponent };